import React from 'react'
import classNames from 'classnames'

/**
 * Вкладки как закладки в книжке: чем дальше от активной — тем темнее фон.
 */
export default function DocTabs({ tabs, selectedTab, onSelect }) {
  if (!tabs || tabs.length <= 1) return null
  const activeIndex = tabs.indexOf(selectedTab)
  return (
    <div className="sigur-doc-tabs-wrapper mb-3">
      <ul className="nav nav-tabs" role="tablist">
        {tabs.map((title, index) => {
          const isActive = title === selectedTab
          const distance = Math.abs(index - activeIndex)
          const side = index < activeIndex ? 'left' : index > activeIndex ? 'right' : 'active'
          const activeEdge = isActive
            ? (activeIndex === 0 ? 'first' : activeIndex === tabs.length - 1 ? 'last' : 'both')
            : undefined
          return (
            <li key={title} className="nav-item" role="presentation">
              <button
                type="button"
                role="tab"
                aria-selected={isActive}
                aria-controls={`tabpanel-${title.replace(/\s+/g, '-')}`}
                id={`tab-${title.replace(/\s+/g, '-')}`}
                className={classNames('nav-link', { active: isActive })}
                data-distance={distance}
                data-side={side}
                data-active-edge={activeEdge}
                onClick={() => onSelect(title)}
              >
                {title}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
